import React, {Component} from 'react';

class PrtCom extends Component {

   render(){ 
    var portraits = require.context("../../../public/images/Photography/Portraits/", false, /.*\.jpg$/);
  return (
    
    <div class="phs1-item">
    <div class="phs1-container">
        <div class="phs1-item">
        {portraits.keys().map((imgs)=>
            <img src={process.env.PUBLIC_URL + "/images/Photography/Portraits/" + imgs.split("/").pop() } class="phs1-img"/>
        )}
        </div>
    </div>
    </div>
  );
}
}
export default PrtCom;
